<form fxLayout="column" name="car-{{ carId }}">
  <div fxLayout="column" fxLayoutAlign="start start">
    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-form-field appearance="outline">
        <mat-label>Compagnia</mat-label>
        <input
          name="car-company"
          matInput
          [(ngModel)]="car.company"
          type="text"
          required
        />
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline">
        <mat-label>Marca e Modello</mat-label>
        <input
          name="car-title"
          matInput
          [(ngModel)]="car.title"
          type="text"
          required
        />
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline">
        <mat-label>Tipo Mezzo</mat-label>
        <mat-select
          [(ngModel)]="car.type"
          name="type"
          [disabled]="disabled"
          required
        >
          <mat-option *ngFor="let type of carTypesData" [value]="type.key">
            {{ type.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-form-field appearance="outline">
        <mat-label>Da (città)</mat-label>
        <input
          name="car-from"
          matInput
          [(ngModel)]="car.from"
          type="text"
          required
        />
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline">
        <mat-label>Da (località)</mat-label>
        <input
          name="car-fromDetail"
          matInput
          [(ngModel)]="car.fromDetail"
          type="text"
        />
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline" class="date">
        <mat-label>Data ritiro</mat-label>
        <input
          name="car-start-date"
          matInput
          readonly
          [matDatepicker]="pickerStart"
          [(ngModel)]="car.start"
          (click)="pickerStart.open()"
          required
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerStart"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerStart></mat-datepicker>
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline" class="time">
        <mat-label>Ora ritiro</mat-label>
        <input
          type="time"
          name="car-start-time"
          matInput
          [ngModel]="car.start?.toDate() | date: 'HH:mm'"
          (ngModelChange)="
            car.start = firestoreTimestampTimeAdapterService.getTimestamp(
              car.start,
              $event
            )
          "
          required
        />
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline">
        <mat-label>Posizione su Mappa</mat-label>
        <mat-icon matSuffix>place</mat-icon>
        <app-lat-lng-input
          [disabled]="disabled"
          [(value)]="car.fromPlace"
          [searchText]="car.from + ' ' + car.fromDetail"
          required
        ></app-lat-lng-input>
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-form-field appearance="outline">
        <mat-label>A (città)</mat-label>
        <input
          name="car-to"
          matInput
          [(ngModel)]="car.to"
          type="text"
          required
        />
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline">
        <mat-label>A (località)</mat-label>
        <input
          name="car-toDetail"
          matInput
          [(ngModel)]="car.toDetail"
          type="text"
        />
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>

      <mat-form-field appearance="outline" class="date">
        <mat-label>Data riconsegna</mat-label>
        <input
          matInput
          readonly
          name="car-end-date"
          [matDatepicker]="pickerEnd"
          [(ngModel)]="car.end"
          (click)="pickerEnd.open()"
          required
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerEnd"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline" class="time">
        <mat-label>Ora riconsegna</mat-label>
        <input
          type="time"
          name="car-end-time"
          matInput
          [ngModel]="car.end?.toDate() | date: 'HH:mm'"
          (ngModelChange)="
            car.end = firestoreTimestampTimeAdapterService.getTimestamp(
              car.end,
              $event
            )
          "
          required
        />
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline">
        <mat-label>Posizione su Mappa</mat-label>
        <mat-icon matSuffix>place</mat-icon>
        <app-lat-lng-input
          [disabled]="disabled"
          [(value)]="car.toPlace"
          [searchText]="car.to + ' ' + car.toDetail"
          required
        ></app-lat-lng-input>
      </mat-form-field>
    </div>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" style="width: 250px;">
      <mat-label>Prezzo totale per {{ npax }} persone</mat-label>
      <input
        name="cost"
        matInput
        [(ngModel)]="car.price"
        type="number"
        required
      />
      <mat-icon matSuffix>euro_symbol</mat-icon>
    </mat-form-field>
    <span>&nbsp;&nbsp;</span>
    <mat-form-field appearance="outline">
      <mat-label>Partner</mat-label>
      <mat-select
        [(ngModel)]="car.partner"
        name="partner"
        [disabled]="disabled"
      >
        <mat-option
          *ngFor="let affiliationPartner of affiliationPartnerData"
          [value]="affiliationPartner.key"
        >
          {{ affiliationPartner.label }}
        </mat-option>
        <mat-option [value]="null">Altro</mat-option>
      </mat-select>
    </mat-form-field>
    <span>&nbsp;&nbsp;</span>
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Link prenotazione</mat-label>
      <input
        name="link"
        matInput
        [(ngModel)]="car.link.longUrl"
        type="url"
        required
      />
      <app-inline-help-button
        matSuffix
        [title]="'Link prenotazione'"
        [content]="
          'Inserisci qui il link alla pagina di prenotazione. Controlla che il link sia funzionante copiandolo e incollandolo in una finestra di navigazione in incognito.'
        "
      >
      </app-inline-help-button>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="center start">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Descrizione</mat-label>
      <textarea
        style="height: 199px;"
        name="car-description"
        matInput
        [(ngModel)]="car.description"
        required
      ></textarea>
      <app-inline-help-button
        matSuffix
        [title]="'Descrizione mezzo'"
        [content]="
          'Inserisci una breve descrizione delle caratteristiche del mezzo. Ad esempio, per auto inserisci informazioni come aria condizionata, cambio manuale o automatico, diesel/benzina/gpl, ecc ecc.\n\nAttenzione a non eccedere lo spazio disponibile nell’itinerario, utilizza la funzione “Anteprima” per controllare. Se lo spazio non è sufficiente, utilizza le note.'
        "
      >
      </app-inline-help-button>
    </mat-form-field>
    <span>&nbsp;&nbsp;</span>
    <app-itinerary-image-form-field
      [disabled]="disabled"
      [(image)]="car.image"
      [label]="'Foto *'"
    ></app-itinerary-image-form-field>
  </div>

  <mat-form-field appearance="outline">
    <mat-label>Note</mat-label>
    <textarea rows="5" name="notes" matInput [(ngModel)]="car.notes"></textarea>
    <app-inline-help-button
      matSuffix
      [title]="'Note'"
      [content]="
        'Inserisci qui un tuo commento personale che motivi i tuoi consigli e le tue scelte per quanto riguarda questa prenotazione.'
      "
    >
    </app-inline-help-button>
  </mat-form-field>
</form>
